import { Controller } from 'stimulus';
import AdUnitSize from '../classes/AdUnitSize';
import AdUnitCondition from '../classes/AdUnitCondition';
import AdUnitPlaceholder from '../classes/AdUnitPlaceholder';
import Utility from '../classes/Utility';
import _ from 'lodash';
class AdUnitController extends Controller {

  initialize() {
    this.adSlot = this.data.get('ad-unit');
    this.adUnit = this.data.get('name');
    this.unitType = this.data.get('type');
    this.isNative = this.data.get('is-native');
    this.id = this.data.get('id');
    this.onlyIf = this.data.get('only-if');
    this.devices = this.data.get('devices');
    this.onlyIfMethod = AdUnitCondition[this.onlyIf];
    this.sizes = Array.from(AdUnitSize.getSize(this.unitType));
    this.keepForPremium = this.data.get('kfp') === 'true';
  }

  async connect() {
    if (this.allowAdsToShowOnDevices(this.devices) && AdUnitPlaceholder.showPlaceholder()) {
      AdUnitPlaceholder.render({
        isNative: this.isNative,
        adUnit: this.adUnit,
        devices: this.devices,
        parentNode: this.element,
        unitType: this.unitType,
        sizes: this.sizes
      })

      return;
    }

    const response = await Utility.getConfigData({
      type: 'isPremium'
    });

    const isPremium = response.data ? response.data : false;
    if (!this.allowAdsToShowOnDevices(this.devices) || (isPremium && !this.keepForPremium )) {
      this.removeAdSlot(this.id);
      return;
    }

    let additionalConditionResult = true;
    if (this.onlyIfMethod != undefined) {
      // check if it's an async method
      if (AdUnitCondition.isAsyncMethod(this.onlyIf)) {
        additionalConditionResult = await this.onlyIfMethod();
      } else {
        additionalConditionResult = this.onlyIfMethod();
      }
    }

    if (this.onlyIf == null || additionalConditionResult) {
      window.EventManager.on('google_ad_loaded', () => {
        googletag.cmd.push(() => {
          let slot = googletag.defineSlot(`/2143012/${this.adUnit}`, this.sizes, this.id)
          Object.keys(window.MConstants.adTargets).forEach(targetKey => {
            const targetValue = window.MConstants.adTargets;
            slot = slot.setTargeting(targetKey, targetValue)
          })
          slot = slot.addService(googletag.pubads());
          googletag.display(this.id);
          if (_.isArray(window.MConstants.adUnits[this.adSlot])){
            window.MConstants.adUnits[this.adSlot].push(slot);
          } else {
            window.MConstants.adUnits[this.adSlot] = [slot];
          }
        });
      });
    } else {
      this.removeAdSlot(this.id);
    }
  }

  allowAdsToShowOnDevices = (devices) => {
    const dt = Utility.getDeviceType();
    if (devices == null || devices.split(',').includes(dt)) {
      return true;
    } else {
      return false;
    }
  }

  removeAdSlot = (id) => {
    const element = document.getElementById(id + '-c');
    element.classList.add('t-hidden');
  }
}

export default AdUnitController;
